import { BANKSTATUS_OPTIONS } from 'constants/filters'

export const useMemberBankAccountsStatuses = () => {
  return {
    memberBankAccountsStatuses: BANKSTATUS_OPTIONS,
  }
}
